import { render, staticRenderFns } from "./UiCookies.vue?vue&type=template&id=cf5d2bf0&"
import script from "./UiCookies.vue?vue&type=script&lang=js&"
export * from "./UiCookies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports